import { TPickerOption, TPickerProps } from "../../../Types";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3Margin from "../../et3-ui/ET3Margin";

const ET3Radio = withLiteObserverAndTheme<TPickerProps>((props) => {
  const { options, value, theme, style, onChoose } = props;
  const { colors, unitX, unitY } = theme;
  const optionsTags = options.map((option: TPickerOption) => (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={true}
      width={200}
      height={50}
      fDirection="row"
      alignItems="center"
      justifyContent="space-around"
      color={colors.all.white}
      style={{
        borderRadius: 39 * unitX,
        cursor: "pointer"
      }}
      onClick={() => {
        onChoose(option.value);
      }}
    >
      <Et3Margin top={0} left={10} right={0} bottom={5}>
        <input
          type="radio"
          value={option.value}
          checked={value === option.value}
          onChange={() => {}}
          style={{
            width: 25 * unitX,
            height: 25 * unitY
          }}
        />
      </Et3Margin>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={140}
        height={50}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.white}
        style={{
          borderRadius: 39 * unitX,
          cursor: "pointer"
        }}
        onClick={() => {
          onChoose(option.value);
        }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={18}
          text={`${option.label}`}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  ));
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={450}
      height={70}
      fDirection="row"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={style}
      onClick={() => {}}
    >
      {optionsTags}
    </ET3Div>
  );
});
export default ET3Radio;
